import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function TermsOfService() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button onClick={() => navigate(-1)} className="mb-8 text-indigo-600 hover:text-indigo-800 font-medium flex items-center gap-2">
          ← Volver
        </button>
        <h1 className="text-4xl font-bold mb-2">Terms of Service</h1>
        <p className="text-gray-500 mb-10">Last updated: April 2, 2026</p>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-3">1. Acceptance of Terms</h2>
            <p className="text-gray-600 leading-relaxed">By accessing or using AdPulse AI ("Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">2. Description of Service</h2>
            <p className="text-gray-600 leading-relaxed">AdPulse AI is a SaaS platform for digital marketing analytics and reporting. The platform allows users and agencies to connect advertising accounts (Meta Ads, Google Ads, Google Analytics 4, Google Search Console), import campaign performance data, generate automated reports, and manage multiple client workspaces from a single dashboard.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">3. Account Registration</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-600">
              <li>You must provide accurate and complete information when creating an account.</li>
              <li>You are responsible for maintaining the confidentiality of your credentials.</li>
              <li>You must notify us immediately of any unauthorized use of your account.</li>
              <li>You must be at least 18 years old to use the Service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">4. Authorized Use of Third-Party APIs</h2>
            <p className="text-gray-600 leading-relaxed mb-3">By connecting your advertising accounts, you authorize AdPulse AI to access your data through official APIs. You represent that:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-600">
              <li>You have the right to authorize access to the connected accounts.</li>
              <li>You will comply with the terms of service of each connected platform.</li>
              <li>The data imported belongs to you or clients you represent with proper authorization.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">5. Subscription and Payments</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-600">
              <li>AdPulse AI is offered on a subscription basis with plans as described on our pricing page.</li>
              <li>Subscriptions are billed monthly or annually in advance.</li>
              <li>Prices may change with 30 days notice.</li>
              <li>Refunds are issued at our discretion within 7 days of purchase for annual plans.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">6. Acceptable Use</h2>
            <p className="text-gray-600 leading-relaxed mb-3">You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-600">
              <li>Use the Service for any illegal purpose.</li>
              <li>Attempt to gain unauthorized access to our systems.</li>
              <li>Reverse engineer or copy any part of the Service.</li>
              <li>Upload malicious code or interfere with the platform.</li>
              <li>Resell or sublicense the Service without written permission.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">7. Data Ownership</h2>
            <p className="text-gray-600 leading-relaxed">You retain ownership of all data imported into AdPulse AI. We do not claim ownership of your advertising data. You grant us a limited license to process and display your data solely to provide the Service.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">8. Intellectual Property</h2>
            <p className="text-gray-600 leading-relaxed">All elements of AdPulse AI — including the platform, interface, algorithms, and reports — are the intellectual property of AdPulse AI. You may not copy, reproduce, or distribute any part of the Service without written authorization.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">9. Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed">AdPulse AI is provided "as is". We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount paid by you in the 3 months prior to the claim.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">10. Termination</h2>
            <p className="text-gray-600 leading-relaxed">We may suspend or terminate your account for violation of these Terms. You may cancel your subscription at any time from your account settings. Upon termination, your data will be retained for 30 days before permanent deletion.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">11. Changes to Terms</h2>
            <p className="text-gray-600 leading-relaxed">We reserve the right to modify these Terms at any time. We will notify you of significant changes via email. Continued use of the Service after changes constitutes acceptance.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">12. Contact</h2>
            <div className="mt-3 p-4 bg-gray-50 rounded-lg">
              <p className="font-semibold">AdPulse AI</p>
              <p className="text-gray-600">Email: legal@adpulseia.com</p>
              <p className="text-gray-600">Website: https://adpulseia.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
